import { Box, Typography } from '@mui/material';
import { FormattedDate } from 'react-intl';
import { CapitalizeFirstLetter } from 'lib/helpers/string-helpers';
import { useServerTimezone } from 'lib/hooks/use-server-timezone';
export function DateCircle({
  value,
  disabled
}: {
  value: Date;
  disabled?: boolean;
}) {
  const {
    formatDate
  } = useServerTimezone();
  return <Box sx={{
    width: 72,
    display: {
      xs: 'none',
      sm: 'flex'
    },
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
      <Typography variant="body1Medium" color={disabled ? 'text.disabled' : 'text.main'}>
        {CapitalizeFirstLetter(formatDate(value, {
        weekday: 'short'
      }))}
      </Typography>
      <Typography color={disabled ? 'text.disabled' : 'text.main'} variant="h3">
        <FormattedDate value={value} day="numeric" />
      </Typography>
    </Box>;
}